import { useTranslation } from 'react-i18next';
import React from 'react';
import Typography from '@src/new-components/Typography';

const Text = ({ text, html }) => {
  const { t } = useTranslation();

  return (
    <Typography variant="body-14-regular" color="#1C1C1E">
      {html || t(text)}
    </Typography>
  );
};

export default Text;
